import PageHeader from '@parts/PageHeader/PageHeader'
import NotFound from 'shared/NotFound/NotFound'

import styles from './notFoundPage.module.scss'
import pageStyles from 'shared/assets/styles/Page.module.scss'

type NotFoundPageProps = {
  errorText?: string
}

const NotFoundPage = ({ errorText }: NotFoundPageProps) => {
  return (
    <div className={pageStyles.page}>
      <div className={styles.contentWrapper}>
        <PageHeader />
        <div className={styles.content}>
          <div className={styles.imgWrapper}>
            <NotFound />
          </div>
          <p className={styles.errorText}>Ошибка: {errorText || 'не найдено'}</p>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage
